import React from 'react'
import { useAuth } from '../contexts/AuthContext'
import Login from './Login'

interface ProtectedRouteProps {
  children: React.ReactNode
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    )
  }

  if (!user) {
    return <Login />
  }

  // Check if user has admin role (you can customize this based on your auth setup)
  // For now, we'll allow any authenticated user since we're using hardcoded credentials
  return <>{children}</>
}

export default ProtectedRoute
